module.exports = __webpack_public_path__ + "media/packs/images/flags/CI-aec1d5e913f5dcf55094777389565f07.png";